import { Helmet } from "react-helmet";
import { Img, Button, Text, Heading } from "../../components";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import LandingpagewipColumn from "./LandingpagewipColumn";
import LandingpagewipColumnTwo from "./LandingpagewipColumnTwo";
import LandingpagewipCtawaitlist from "./LandingpagewipCtawaitlist";
import LandingpagewipRowOne from "./LandingpagewipRowOne";
import LandingpagewipRowmeettheheroe from "./LandingpagewipRowmeettheheroe";
import LandingpagewipRowquestion from "./LandingpagewipRowquestion";
import LandingpagewipStackwhylifetoo from "./LandingpagewipStackwhylifetoo";
import React from "react";
import { Link } from 'react-router-dom';
import useIsMobile from "../../utils/useIsMobile";

export default function LandingpageWIPPage() {
  const isMobile = useIsMobile();
  const sectionRefs = React.useRef({
    home: React.createRef(),
    createComic: React.createRef(),
    pricing: React.createRef(),
    aboutUs: React.createRef(),
    contact: React.createRef(),
  });

  return (
    <>
      <Helmet>
        <title>Lifetoon</title>
        <meta name="description" content="Web site created using create-react-app" />
      </Helmet>
      <div className="w-full bg-white">
        <div>
          <Header refs={sectionRefs} />
          <div ref={sectionRefs.current.home} className="relative h-[fit-content] mt-[14vh] content-center md:h-auto sm:mt-[40px] mt-[130px]">
            <div className="ml-[4.5vw] flex flex-col items-start gap-8 sm:top-[15%]">
              <div className="flex flex-col items-start gap-5">
                <Heading
                  as="h2"
                  className="w-[60%] !font-chewy text-[4.4vw] font-normal md:px-5 md:text-[48px] sm:text-[32px] sm:w-full sm:leading-[100%]"
                >
                  <span className="text-dark_blue_secondary">Turn Life’s Moments into&nbsp;</span>
                  <span className="text-orange_accent1">Legendary</span>
                  <span className="text-dark_blue_secondary">&nbsp;</span>
                  <span className="text-orange_accent1">Comics</span>
                </Heading>
                <Text as="p" className="w-[45%] text-[1vw] md:text-[16px] md:w-[60vw] font-normal md:px-5 sm:text-[16px] sm:w-full sm:px-4">
                  A photo captures a moment, but a story brings it to life. Lifetoon transforms your memories into
                  personalized comics, turning milestones, connections, and special moments into immersive,
                  one-of-a-kind narratives to treasure forever.
                </Text>
              </div>
              <Link to="formnew">
                <Button
                  rightIcon={
                    <Img
                      src="images/img_arrowright.svg"
                      alt="Arrow Right"
                      className="mb-1 mt-0.5 h-[50%] w-[50%] object-contain"
                    />
                  }
                  className=" md:mb-[4vw] md:text-[16px] md:ml-[20px] min-w-[20vw] h-[7.5vh] gap-1.5 rounded-[2vw] sm:rounded-[50px] px-[30px] font-medium italic shadow-md sm:px-5 
           bg-orange_accent1 text-dark_blue_secondary
           border-2 border-solid border-dark_blue_secondary border-b-8
           hover:bg-[#FFE3A3] hover:border-0 hover:text-dark_blue_secondary
           transition-all duration-300 ease-in-out sm:min-w-[280px] sm:px-4 text-[1.2vw] sm:text-[14px] sm:font-semibold sm:ml-[16px]"
                >
                  Create your comic now
                </Button>
              </Link>
            </div>
            {isMobile? 
            <div className="flex flex-1 flex-col items-center">
              <Img src="images/heropicture.jpg" alt="Poza pe bula galbenă" className="heropicture w-[80%] sm:mt-[40px]" /> 
            </div>:
            <Img src="images/heropicture.jpg" alt="Poza pe bula galbenă" className="heropicture absolute top-[20vh] left-[76vw] transform translate-x-[-50%] translate-y-[-50%] w-[20%] z-10 transform rotate-[12deg] sm:w-[50%] sm:h-[50%]" />
            }
            {!isMobile && <Img src="images/norisor2.svg" alt="Norisor2" className="norisor2 absolute z-20 top-[-9vw] md:top-[2vw] right-[6vw] w-[9vw] object-contain sm:h-[250px] sm:w-[30%]" />}
            { !isMobile && <Img src="images/norisor1.svg" alt="Image" className="norisor1 absolute w-[12%] top-[30vh] right-[30%] z-20 object-contain ml-auto sm:w-[50%] sm:h-[300px]" />}
          </div>
          <div className="w-[100%] flex flex-1 flex-col items-center mt-[10vh] sm:mt-[40px]">
            <div className="w-[80%] flex flex-1 flex-col items-end">
                <LandingpagewipColumn />
            </div>
          </div>
          <div className="relative mt-[6vw] h-[fit-content] md:h-auto sm:mt-[40px]">
            {!isMobile && <Img src="images/img_rectangle_15.png" alt="Image" className="mt-36 h-[50vw] absolute z-0 sm:h-[400px] sm:w-full" />}
            <div className=" relative flex-col gap-[106px] md:gap-[79px] sm:gap-[53px]">
              <LandingpagewipRowOne />
              <LandingpagewipStackwhylifetoo />
            </div>
          </div>

          {!isMobile && <Img src="images/img_subtract.svg" alt="Subtract" className=" w-[100vw] md:h-auto mt-[4vw] md:mt-[80px] sm:h-[100px]" />}
          <div ref={sectionRefs.current.pricing}>
            <LandingpagewipColumnTwo />
          </div>

          <div ref={sectionRefs.current.aboutUs}>
            <LandingpagewipRowmeettheheroe />
          </div>

          <LandingpagewipRowquestion />

          <div>
            <LandingpagewipCtawaitlist />
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}
